module.exports = __webpack_public_path__ + "img/Battle4.86480468.jpg";